<mat-form-field
  class="mat-block"
  [ngClass]="{'l-updated-field': isDefaultLanguage == true && !isOrgNode}"
>
  <mat-select
    id="ddLanguage"
    [formControl]="ctrl"
    [placeholder]="placeholder"
    [required]="ctrl.hasError('required')"
  >
    <mat-option *ngFor="let language of languageList" [value]="language">
      {{language.name}}
    </mat-option>
  </mat-select>
  <mat-error
    id="errLanguage"
    class="error-message"
    *ngIf="ctrl.hasError('required') &&
     (ctrl.dirty ||ctrl.touched)"
  >
    {{ "common.language_required" | translate }}
  </mat-error>
</mat-form-field>
